<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta"
      >
        <v-card color="green" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Empresas</div>
              <span>Número de empresas no sistema:</span>
              <span class="subheading mr-2">{{
                dados.numeroTotalEmpresas
              }}</span>
              <br />
              <span>Empresas clientes:</span>
              <span class="subheading mr-2">{{
                dados.numeroClientesEmpresas
              }}</span>
              <br />
              <span>Empresas descartadas:</span>
              <span class="subheading mr-2">{{
                dados.numeroDescatadosEmpresas
              }}</span>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat dark @click="go('Empresas')">Ver agora</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta"
      >
        <v-card color="blue-grey darken-1" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Agendas</div>

              <span>Número de agendas no sistema:</span>
              <span class="subheading mr-2">{{
                dados.numeroAgendaAbertas + dados.numeroAgendaFechadas
              }}</span>
              <br />
              <span>Total de agendas abertas:</span>
              <span class="subheading mr-2">{{
                dados.numeroAgendaAbertas
              }}</span>
              <br />
              <span>Total de agendas fechadas:</span>
              <span class="subheading mr-2">{{
                dados.numeroAgendaFechadas
              }}</span>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat dark @click="go('Agendas')">Ver agora</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta"
      >
        <v-card color="cyan darken-2" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Pessoas</div>
              <br />
              <span>Número de pessoas no sistema:</span>
              <span class="subheading mr-2">{{ dados.numeroPessoas }}</span>
              <br />
              <br />
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat dark @click="go('Pessoas')">Ver agora</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario == perfilUsr.ID.administrador"
      >
        <v-card color="#26c6da" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Franquias</div>
              <br />
              <span>Número de franquias no sistema:</span>
              <span class="subheading mr-2">{{ dados.numeroContas }}</span>
              <br />
              <br />
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat dark @click="go('Contas')">Ver agora</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario != perfilUsr.ID.clienteMetta"
      >
        <v-card color="purple" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Prospecções</div>
              <span>Número de Prospecções:</span>
              <span class="subheading mr-2">{{
                dados.numeroProspetadosEmpresas
              }}</span>
              <br />
              <span>Total dividas Estadual:</span>
              <span class="subheading mr-2">{{
                dados.numeroEmpresasProspValorEst.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <br />
              <span>Total dividas Federal:</span>
              <span class="subheading mr-2">{{
                dados.numeroEmpresasProspValorFed.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat dark @click="go('Empresas')">Ver agora</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario == perfilUsr.ID.clienteMetta"
      >
        <v-card color="#26c6da" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Caro Cliente</div>
              <br />
              <span class="subheading mr-2"
                >Envie suas informações para analise, para ter acesso a plataforma. </span
              >
              <br />
              <br />
              <br />
              <br />
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario == perfilUsr.ID.clienteMetta"
      >
        <v-card color="purple" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Meus Download`s</div>
              <span class="subheading mr-2">Anexe aqui:<br /></span>
              <span>
                Contrato Social<br />
                Documento dos Socios e Comprovante de Endereço<br />
                Comprovante de faturamento dos ultimos 12 mês<br />
              </span>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat dark @click="go('Download')">Ver agora</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        lg3
        v-if="usuarioLogado.idtipousuario == perfilUsr.ID.clienteMetta"
      >
        <v-card color="blue-grey darken-1" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Meu perfil</div>
              <!-- <span>Número de download`s:</span>
              <span class="subheading mr-2">{{
                dados.numeroProspetadosEmpresas
              }}</span> 
              <br />-->
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
              flat
              dark
              @click="editarUsuario(cipherComputed.encrypt(usuarioLogado.id))"
              >Ver agora</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import usuarioHelper from "@/helpers/usuario.js";
import perfil from "@/helpers/perfil.js";
import cipher from "@/helpers/cipher.js";

export default {
  name: "Portal",
  data: () => ({
    dados: {
      numeroAgendaAbertas: 0,
      numeroAgendaFechadas: 0,
      numeroEmpresas: 0,
      numeroEmpresasProspValorEst: 0.0,
      numeroEmpresasProspValorFed: 0.0,
      numeroPessoas: 0,
      numeroContas: 0,
    },
  }),
  mounted: function () {
    //this.$store.commit("startLoading");
    this.buscarDados();
    //this.$store.commit("endLoading");
  },
  computed: {
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },

    perfilUsr: function () {
      return perfil;
    },
    cipherComputed: function () {
      return cipher;
    },
  },
  methods: {
    buscarDados: function () {
      const self = this;

      self.$http
        .get(
          `${process.env.URL_API}/portal/v1/busca/` +
            self.usuarioLogado.idconta,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          }
        )
        .then(function (response) {
          self.dados = response.data;
        });
    },
    editarUsuario: function (id) {
      const self = this;
      self.$router.push({ name: "CadastroUsuario", params: { id: id } });
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (this.$router.currentRoute.name != routeName) {
        if (!routeParams) {
          self.$router.push({ name: routeName });
        } else {
          self.$router.push({ name: routeName, params: routeParams });
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/portal/Portal.vue